import { render } from "./NotFound.vue?vue&type=template&id=671089ba"
const script = {}

import exportComponent from "/var/www/html/projects/petcare_admin_panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__